<template>
  <div class="col-lg-6 mb-1">
    <div class="ibox-body">
      <div class="ibox-title style_2">
        <h5>Modify Exisiting eCRF</h5>
      </div>
      <div class="ibox-content horizondalscroll" :id="treeNodeId('modify', 'scrollBody')">
        <ul class="tree pl-1">
          <li v-for="(site, sIndex) in sites" :key="treeNodeId('modify', 'site-row', site.siteID)">
            <input
              type="checkbox"
              :id="treeNodeId('modify', 'site', site.siteID)"
              @change="getpatient(site.siteID, sIndex, 'modify')"
            />
            <label class="tree_label" :for="treeNodeId('modify', 'site', site.siteID)">
              {{ site.siteCode }}
            </label>
            <ul
              v-for="(patient, pIndex) in treeStates.modify.patientLists[sIndex]"
              :for="treeNodeId('modify', 'site', site.siteID)"
              :key="treeNodeId('modify', 'patient-row', patient.patientId)"
            >
              <li>
                <input
                  type="checkbox"
                  :id="treeNodeId('modify', 'patient', patient.patientId)"
                  @change="getVisits(patient.patientId, pIndex, 'modify')"
                />
                <label :for="treeNodeId('modify', 'patient', patient.patientId)" class="tree_label">
                  {{ patient.subjectId }}
                </label>
                <ul>
                  <li v-for="node in getFormNodes(patient.patientId)" :key="node.key">
                    <template v-if="node.type === 'group'">
                      <input type="checkbox" :id="treeNodeId('modify', 'form-group', node.key)" />
                      <label class="tree_label" :for="treeNodeId('modify', 'form-group', node.key)">
                        {{ node.formName }}
                      </label>
                      <ul>
                        <li
                          v-for="form in node.forms"
                          :key="treeNodeId('modify', 'form-detail', form.formId)"
                        >
                          <input type="checkbox" :id="treeNodeId('modify', 'form', form.formId)" />
                          <label class="tree_label" :for="treeNodeId('modify', 'form', form.formId)">
                            <a @click.prevent="openForm(form, patient)">
                              {{ groupedFormText(form) }}
                            </a>
                          </label>
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <input type="checkbox" :id="treeNodeId('modify', 'form', node.form.formId)" />
                      <label class="tree_label" :for="treeNodeId('modify', 'form', node.form.formId)">
                        <a @click.prevent="openForm(node.form, patient)">
                          {{ formLeafText(node.form) }}
                        </a>
                      </label>
                    </template>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModifyExistingEcrfTree",
  props: {
    sites: {
      type: Array,
      default: () => []
    },
    treeStates: {
      type: Object,
      required: true
    },
    handlers: {
      type: Object,
      required: true
    }
  },
  methods: {
    callHandler(name, ...args) {
      const handler = this.handlers?.[name];
      return typeof handler === "function" ? handler(...args) : undefined;
    },
    treeIdPart(value) {
      return String(value == null ? "" : value).replace(/[^A-Za-z0-9_-]/g, "-");
    },
    treeNodeId(treeKey, ...parts) {
      return [treeKey, ...parts].map(part => this.treeIdPart(part)).join("-");
    },
    formGroupKey(formName) {
      return String(formName || "Unnamed Form").trim().toLowerCase();
    },
    getFormNodes(patientId) {
      const forms = this.treeStates.modify.formDetails[patientId] || [];
      const groups = new Map();

      forms.forEach((form) => {
        const displayName = String(form.formName || "Unnamed Form").trim();
        const key = this.formGroupKey(displayName);
        if (!groups.has(key)) {
          groups.set(key, {
            key,
            formName: displayName,
            forms: []
          });
        }
        groups.get(key).forms.push(form);
      });

      return Array.from(groups.values()).map((group) => {
        if (group.forms.length > 1) {
          return {
            type: "group",
            key: `group-${group.key}`,
            formName: group.formName,
            forms: group.forms
          };
        }

        return {
          type: "form",
          key: `form-${group.forms[0].formId}`,
          form: group.forms[0]
        };
      });
    },
    formLeafText(form, groupedFormName = "") {
      const parts = [];
      if (form.visitName) {
        parts.push(form.visitName);
      } else if (form.formName && form.formName !== groupedFormName) {
        parts.push(form.formName);
      }
      if (form.formStatus) {
        parts.push(form.formStatus);
      }

      return parts.join(" - ") || form.formName || "Form";
    },
    groupedFormText(form) {
      const parts = [form.formName || form.templateName || "Form"];
      const createdAt = this.formatCreatedAt(form.createdAt);
      if (createdAt) {
        parts.push(createdAt);
      }

      return parts.join(" - ");
    },
    formatCreatedAt(createdAt) {
      if (!createdAt) {
        return "";
      }

      const formattedDate = this.callHandler("filter", createdAt);
      if (formattedDate) {
        return formattedDate;
      }

      const date = new Date(createdAt);
      return Number.isNaN(date.getTime()) ? createdAt : date.toLocaleDateString();
    },
    openForm(form, patient) {
      return this.viewform(
        form.formId,
        form.siteId,
        patient.subjectId,
        form.subjectId,
        form.studyId
      );
    },
    getpatient(...args) {
      return this.callHandler("getpatient", ...args);
    },
    getVisits(...args) {
      return this.callHandler("getVisits", ...args);
    },
    viewform(...args) {
      return this.callHandler("viewform", ...args);
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
@import "../Submit_Form/tree.css";

.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}
</style>
